<template>
  <div class="callback-container isolated-component">
    <div v-if="loading" class="loading">
      <p>登录中，请稍候...</p>
    </div>
    <div v-if="error" class="error">
      <p>{{ error }}</p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { QcWxLogin } from "@/api";
import { getQueryParams, isNotWidthPhone } from "@/utils";
import { homeOnOfficialMediaCompleteReporting } from "@/utils/reporting";

const loading = ref(true);
const error = ref("");

// 处理QQ登录
const handleQQLogin = async () => {
  const code = getQueryParams("code");
  const originalUrl = getQueryParams("originalUrl");
  const action = getQueryParams("action");

  if (!code) {
    loading.value = false;
    error.value = "未获取到授权码，请重试";
    return;
  }
  if (!originalUrl) {
    loading.value = false;
    error.value = "未获取到originalUrl，请重试";
    return;
  }
  try {
    // 向后端发送请求验证登录
    const response = await QcWxLogin({
      code,
      channel: action == "loginManager_WX_PC" ? 1 : 2,
      redirect_uri: `https://gh.sarosgame.com/callback`,
    });

    if (response.token) {
      homeOnOfficialMediaCompleteReporting("loginManager_WX_PC" ? 2 : 1);
      localStorage.setItem("channel", "loginManager_WX_PC" ? 2 : 1);
      if (isNotWidthPhone()) {
        localStorage.setItem("token", response.token);
        window.location.href = "/";
        return;
      } else {
        // 登录成功，向原始页面发送消息
        if (window.opener) {
          window.opener.postMessage(
            {
              type: "loginManager_QW_PC",
              code,
              token: response.token,
              originalUrl: originalUrl,
            },
            "*"
          );

          // 短暂延迟后关闭窗口
          setTimeout(() => {
            window.close();
          }, 300);
        } else {
          loading.value = false;
          error.value = "无法向原始页面发送消息";
        }
      }
    } else {
      loading.value = false;
      error.value = response.msg || "登录失败，请重试";
    }
  } catch (err) {
    loading.value = false;
    error.value = "服务器错误，请稍后重试";
    console.error("QQ login error:", err);
  }
};

onMounted(() => {
  handleQQLogin();
});
</script>

<style scoped>
.callback-container {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
  font-family: Arial, sans-serif;
}

.loading {
  font-size: 16px;
  color: #333;
}

.error {
  font-size: 50px;
  color: #f44336;
  margin: 20px;
}

.close-btn {
  background-color: #4caf50;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
}
</style>
